import i18n from '@/plugins/i18n';
import {AuthorProfile, MyProfileAPI} from '#/User';

export const SYNC_ERROR_MSG = i18n.t('external.error.syncFailed');

export const emptyAuthor = (): AuthorProfile => ({
    censured: false,
    description: null,
    firstName: '',
    id: 0,
    isAdmin: false,
    lastLogin: new Date(),
    name: '',
    profileColor: '',
    profilePhoto: null,
    profileUrl: null,
    username: '',
});


export const emptyProfile = (): MyProfileAPI => ({
    blacklist: [],
    defaultFilter: null,
    description: '',
    email: '',
    firstName: '',
    gdprAccepted: false,
    id: 0,
    isAdmin: false,
    name: '',
    nickname: null,
    organization: '',
    profileColor: '',
    profilePhoto: null,
    profileUrl: null,
    syncError: false,
    termsAccepted: false,
    useEmailNotification: false,
    useErnestNotification: false,
    useErnestProfile: false,
    useMessageNotification: false,
    username: '',
});

export interface ProfileState {
    authorProfile: AuthorProfile;
    profile: MyProfileAPI;
    profileStored: boolean;
}

export const state: ProfileState = {
    authorProfile: emptyAuthor(),
    profile: emptyProfile(),
    profileStored: false,
};
